var map = {
	"./languages.demo.digvurd.gb-en.json": 68,
	"./languages.demo.digvurd.nb-no.json": 69,
	"./languages.gb-en.json": 70,
	"./languages.hiof.gb-en.json": 71,
	"./languages.hiof.nb-no.json": 72,
	"./languages.nb-no.json": 73,
	"./languages.uit.gb-en.json": 74,
	"./languages.uit.nb-no.json": 75,
	"./languages.usn.gb-en.json": 76,
	"./languages.usn.nb-no.json": 77,
	"./languages.usn.vernepleie.gb-en.json": 78,
	"./languages.usn.vernepleie.nb-no.json": 79,
	"./languages.vid.gb-en.json": 80,
	"./languages.vid.nb-no.json": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;